import React, { useState, useEffect } from "react";
import BodyFeedback from "./BodyFeedback";
import { supabase } from "./supabaseClient";

const STYLE_LABELS = {
  orthodox: "Orthodox",
  southpaw: "Southpaw",
  philly_shell: "Philly Shell",
  peek_a_boo: "Peek-a-Boo",
  soviet: "Soviet/Kronk",
  swarmer: "Swarmer"
};

function FeedbackHistory({ user }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    supabase
      .from("feedback_history")
      .select("*")
      .eq("user_id", user.id)
      .order("created_at", { ascending: false })
      .then(({ data }) => {
        setHistory(data || []);
        setLoading(false);
      });
  }, [user]);

  if (loading) return (
    <div style={{textAlign:"center",padding:"50px"}}>
      <p style={{color:"#555",fontFamily:"Inter, sans-serif"}}>Loading your history...</p>
    </div>
  );

  if (history.length === 0) return (
    <div style={{backgroundColor:"rgba(255,255,255,0.02)",padding:"50px",borderRadius:"16px",textAlign:"center",border:"1px solid rgba(255,255,255,0.05)"}}>
      <div style={{fontSize:"3rem",marginBottom:"15px"}}>📹</div>
      <p style={{color:"#555",fontFamily:"Inter, sans-serif",fontSize:"1rem"}}>No sessions yet. Upload your first training video to get started!</p>
    </div>
  );

  return (
    <div style={{fontFamily:"Inter, sans-serif"}}>
      <p style={{color:"#555",marginBottom:"25px",fontSize:"0.9rem"}}>{history.length} training session{history.length !== 1 ? "s" : ""} recorded</p>
      {history.map((item, index) => (
        <div key={item.id} style={{
          background: expanded === item.id ? "linear-gradient(135deg, rgba(233,69,96,0.08), rgba(255,107,53,0.04))" : "rgba(255,255,255,0.02)",
          borderRadius:"16px",
          marginBottom:"12px",
          border: expanded === item.id ? "1px solid rgba(233,69,96,0.3)" : "1px solid rgba(255,255,255,0.06)",
          overflow:"hidden",
          transition:"all 0.2s"
        }}>
          <div
            onClick={() => setExpanded(expanded === item.id ? null : item.id)}
            style={{padding:"20px 25px",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{display:"flex",alignItems:"center",gap:"15px"}}>
              <div style={{
                background:"linear-gradient(135deg, #e94560, #ff6b35)",
                borderRadius:"10px",
                width:"40px",height:"40px",
                display:"flex",alignItems:"center",justifyContent:"center",
                fontSize:"1.2rem",flexShrink:0
              }}>🥊</div>
              <div>
                <p style={{color:"white",margin:0,fontWeight:"600",fontSize:"0.95rem"}}>{STYLE_LABELS[item.style] || item.style} Session</p>
                <p style={{color:"#555",margin:"3px 0 0 0",fontSize:"0.8rem"}}>{new Date(item.created_at).toLocaleDateString("en-US", { weekday:"short", month:"short", day:"numeric", year:"numeric" })}</p>
              </div>
            </div>
            <div style={{color:"#555",fontSize:"1.2rem",transition:"transform 0.2s",transform: expanded === item.id ? "rotate(180deg)" : "rotate(0deg)"}}>▾</div>
          </div>
          {expanded === item.id && (
            <div style={{padding:"0 25px 25px 25px",borderTop:"1px solid rgba(255,255,255,0.05)"}}>
              {item.analysis && (
                <div style={{paddingTop:"20px",marginBottom:"20px"}}>
                  <BodyFeedback analysis={item.analysis} />
                </div>
              )}
              <div style={{paddingTop: item.analysis ? "0" : "20px",color:"#ccc",lineHeight:"1.9",whiteSpace:"pre-wrap",fontSize:"0.9rem"}}>{item.feedback}</div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default FeedbackHistory;
